import { useDispatch, useSelector } from "react-redux";
import Table from "../../common/Table";
import { useCallback, useEffect, useState } from "react";
import {
  addExamType,
  deleteExamType,
  editExamType,
  getExamType,
  getSingleExamType,
} from "../../redux/services/examTypeSlice";
import ExamTypeForm from "./examTypeForm";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import { exportToTablePDF } from "../../common/PdfFormat";
import ConfirmationPage from "../../common/ConfirmationPage";

const ExamType = () => {
  const dispatch = useDispatch();
  const getExamTypeData = useSelector((state) => state?.examType?.examTypeData);
  const getSingleExamData = useSelector(
    (state) => state?.examType?.singleExamTypeData
  );
  const [modelOpen, setModelOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [editId, setEditId] = useState();
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const initialValues = {
    name: "",
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Exam Type  is required"),
  });
  const getAllExam = useCallback(async () => {
    try {
      await dispatch(
        getExamType({ page: page + 1, limit: pageLimit, searchData })
      );
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllExam();
  }, [getAllExam]);

  const onSubmit = async () => {
    setLoading(true);
    const payload = { ...values };
    if (editId) {
      payload.examTypeId = editId;
    }
    try {
      let response;
      if (editId) {
        response = await dispatch(editExamType(payload));
      } else {
        response = await dispatch(addExamType(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        setModelOpen(false);
        resetForm();
        getAllExam();
      }
    } catch (error) {}
    setModelOpen(false);
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const deleteExamData = async () => {
    try {
      const response = await dispatch(deleteExamType(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllExam();
    } catch (error) {}
  };

  useEffect(() => {
    if (editId) {
      const fetchSingleExam = async () => {
        try {
          await dispatch(getSingleExamType(editId));
        } catch (error) {}
      };

      fetchSingleExam();
    }
  }, [dispatch, editId]);

  useEffect(() => {
    if (getSingleExamData) {
      setValues({
        name: getSingleExamData.name,
      });
    }
  }, [getSingleExamData, setValues]);

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Name",
      key: "name",
    },
  ];
  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setEditId(row._id);
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      { label: "S/N", key: "index", render: (_, __, index) => index + 1 },
      {
        label: "Name",
        key: "name",
        render: (_, row) => row?.name || "-",
      },
    ];
    const data = getExamTypeData?.exam_type_data || [];
    exportToTablePDF({
      tableName: "Exam Type Data",
      data,
      headersConfig,
      pdfName: "exam_type_data.pdf",
    });
  };
  return (
    <>
      <Table
        title="Exam Type"
        buttonTitle="Add Exam Type"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => setModelOpen(true)}
        columns={columns}
        data={getExamTypeData?.exam_type_data || []}
        actions={actions}
        pageCount={getExamTypeData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Exam Type"
          confirm={confirm}
          onDelete={deleteExamData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <ExamTypeForm
          modelOpen={modelOpen}
          setModelOpen={setModelOpen}
          onClose={() => {
            setModelOpen(false);
            resetForm();
            setEditId();
          }}
          values={values}
          handleChange={handleChange}
          editId={editId}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}
    </>
  );
};

export default ExamType;
